// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + "tire-recommender" + "." + "db6317e99a4d13f856b9" + ".min.js";
};